module.exports = __webpack_public_path__ + "img/box-1-eng.1e83eafb.png";